export default __webpack_public_path__ + "static/media/issue_img.fcd529e6.png";